<template>
  <div class="dashboard">
    <Title />
    <v-container>
      <AppFilter v-model="form" />
      <Application v-for="(item, i) in docs" :key="i" :item="item" @onPDF="reset()" />
      <infinite-loading ref="infinite" @infinite="loadMore"></infinite-loading>
    </v-container>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Title from "../dashboard/Title.vue";
import AppFilter from "../dashboard/Filter";
import Application from "../dashboard/Application.vue";
import { fs } from "../assets/js/firebase.js";
import moment from "moment";
export default {
  components: {
    Title,
    AppFilter,
    Application,
    InfiniteLoading
  },
  data() {
    return {
      lastSnap: null,
      docs: [],
      form: {
        pdf: false,
        from: moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD")
      }
    };
  },
  watch: {
    form() {
      this.reset();
    }
  },
  methods: {
    reset() {
      console.log("welcome");
      const vm = this;
      vm.docs = [];
      vm.$refs.infinite.stateChanger.reset();
      vm.lastSnap = null;
    },
    loadMore() {
      const vm = this;
      let $state = vm.$refs.infinite.stateChanger;
      let query = fs.collection("forms").orderBy("timestamp", "desc");
      if (vm.form.pdf) {
        query = query.where("doc_upload", "==", false);
      } else {
        let from = moment(vm.form.from);
        from = new Date(new Date(from).setHours(0, 0)).getTime();
        let to = moment(vm.form.to);
        to = new Date(new Date(to).setHours(23, 59)).getTime();
        query = query.where("timestamp", ">", from).where("timestamp", "<", to);
        if (vm.form.property)
          if (vm.form.property === "Unsure") {
            query = query.where("leaseInfo.add1", "==", "");
          } else {
            query = query.where("leaseInfo.add1", "==", vm.form.property);
          }
      }
      if (vm.lastSnap !== null) query = query.startAfter(vm.lastSnap);
      query = query.limit(10);
      query
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data();
            data.id = doc.id;
            vm.docs.push(data);
            vm.lastSnap = doc;
          });
          if (snap.empty) {
            $state.complete();
          }
          $state.loaded();
        })
        .catch(({ message }) => {
          $state.loaded();
          $state.complete();
          console.log(message);
          vm.$root.alert(message);
        });
    }
  }
};
</script>
